import { ReportLog } from "../api/Reports";
import { classNames, formattedDate, LONG_TEXT_WRAP_CLASSES } from "../utils";

interface ReportNotesProps {
  Note: ReportLog;
}

const ReportNote = ({ Note }: ReportNotesProps) => {
  function getDisplayDate(datePosted: Date): string {
    if (datePosted) {
      return formattedDate(datePosted);
    }
    return "";
  }
  return (
    <>
      <div className="p-2 min-w-0">
        <div className="flex flex-col p-1 min-w-0">
          <div
            className={classNames(
              "text-md font-semibold ml-4",
              LONG_TEXT_WRAP_CLASSES
            )}
          >
            {Note.name}
          </div>
          <div
            className={classNames(
              "text-sm font-medium ml-4",
              LONG_TEXT_WRAP_CLASSES
            )}
          >
            {getDisplayDate(Note.created_at)}
          </div>
        </div>
        <div
          className={classNames(
            "mb-3 p-4 text-md break-all",
            LONG_TEXT_WRAP_CLASSES
          )}
        >
          {Note.log_message}
        </div>
      </div>
    </>
  );
};

export default ReportNote;
